import { BaseEntity } from ".";
import { IGet_corporations_corporation_id_wallets_200_ok } from "../service/esiclient";

export class CorporationWalletEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Corporation Wallet";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_corporations_corporation_id_wallets_200_ok> = this.props;
    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      if (props.balance) {
        entity.properties["balance"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: props.balance,
          numberFormat: "##0",
        };
      }
      if (props.division) {
        entity.properties["division"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: props.division,
          numberFormat: "#",
        };
      }
      if (props.balance && props.division) {
        entity.text = "Div. " + props.division.toString() + ": " + props.balance.toString() + " ISK";
      } else if (props.balance) {
        entity.text = props.balance.toString();
      } else {
        entity.text = "Div. " + props.division + ": 0 ISK";
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        //title: { property: "name" },
      },
    };
    return entity;
  }
}
